import pluralize from 'pluralize';

type ObjectDefinition = {
    color: string;
    endpoint: string;
    name: string;
    pluralName?: string; // this shouldn't be set manually in most cases
};

type SupportedObjects = {
    [key: string]: ObjectDefinition;
};

export const supportedObjects:SupportedObjects = {
    /*
    |--------------------------------------------------------------------------
    | Primary Objects
    |--------------------------------------------------------------------------
    */
    contact: {
        color: 'contact',
        endpoint: 'contacts',
        name: 'Contact',
    },
    business: {
        color: 'business',
        endpoint: 'businesses',
        name: 'Business',
    },
    property: {
        color: 'property',
        endpoint: 'properties',
        name: 'Property',
    },
    workplan: {
        color: 'workplan',
        endpoint: 'work-plans',
        name: 'Work Plan',
    },
    event: {
        color: 'event',
        endpoint: 'events',
        name: 'Event',
    },
    opportunity: {
        color: 'default',
        endpoint: 'opportunities',
        name: 'Volunteer Opportunity',
    },
    donation: {
        color: 'donation',
        endpoint: 'donations',
        name: 'Donation',
    },

    /*
    |--------------------------------------------------------------------------
    | Secondary / Other
    |--------------------------------------------------------------------------
    */
    default: {
        color: 'default',
        endpoint: '',
        name: '',
    },

}

type SupportedObject = keyof typeof supportedObjects;

export const objectDefinition = (object:SupportedObject):ObjectDefinition => {
    const definition = supportedObjects[object];

    // set other options that can be inferred
    if(!definition.pluralName) {
        definition.pluralName = pluralize(definition.name);
    }

    return definition;
};
